<ng-container *transloco="let convert;">
  <app-modal tabindex="-1" [modalId]="'provinceRestrictionModal'">
    <div class="modal-close-container">
      <button
        class="modal__close"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="close()"
      >
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>

    <header class="modal__header">
      <h4 class="modal__title text-brand" tabindex="-1" aria-hidden="true" [innerHTML]=
        "convert('sellModule.posting.newPosting.newPostingModal.textNeedMoreInfoForPosting')">
      </h4>
    </header>

    <div class="modal__content">
      <div class="modal__body">
      <span>{{convert('sellModule.posting.newPosting.newPostingModal.textContactCardInfoForPostingFirstPart')}}
      <a
        data-track-name="phone"
        [attr.data-track-elem]="tenantPhoneNumber | formatPhoneNumber"
        [href]="tenantPhoneNumber | telephoneLink"
        attr.aria-label="Phone: {{ tenantPhoneNumber | formatPhoneNumber }}"
        class="deskmenu-phone">
        {{ tenantPhoneNumber | formatPhoneNumber }}</a>
        {{convert('sellModule.posting.newPosting.newPostingModal.textContactCardInfoForPostingLastPart')}}</span>
        <br>
        <br>
        <div class="modal__actions">
          <button
            class="btn btn-primary"
            data-track-name="Ok"
            (click)="close()"
            [attr.aria-label]="convert('common.btnOk')">
            {{convert('common.btnOk')}}
          </button>
        </div>
      </div>
    </div>
  </app-modal>
</ng-container>
